import {getParameterByName} from '../../../../../../shared/scripts/ui_utils/ClientUtils'
import {UIStoreBodyController} from '../../../../../../shared/scripts/store/UIStoreBodyController'
import {UIStoreController} from '../../../../../../shared/scripts/store/UIStoreController'
import {UIStoreState} from '../../../../../../shared/scripts/store/UIStoreState'
import {CA} from '../../../../../../shared/scripts/analytics/Analytics'
import {UIMStoreBodyController} from './UIMStoreBodyController'
import {UIMStoreSidebarController} from './UIMStoreSidebarController'

export class UIMStoreController extends UIStoreController {
    readonly sidebarController: UIMStoreSidebarController
    readonly storeState: UIStoreState
    readonly bodyController: UIStoreBodyController
    readonly headerCoinsContainer: HTMLDivElement

    constructor() {
        super()
        this.sidebarController = new UIMStoreSidebarController()
        this.storeState = new UIStoreState(this)
        this.bodyController = new UIMStoreBodyController(this.storeState, this.sidebarController)

        const purchaseSuccess = getParameterByName('purchase-success')
        if(purchaseSuccess != '1') return
        CA.sendGoogleTagManagerEvent(CA.GoogleTagManagerEvent.PurchaseCompleted)
    }
}
